/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    InternalApiScreeningEvent,
    InternalApiScreeningEventFromJSON,
    InternalApiScreeningEventToJSON,
} from '../models';

export interface GetScreeningEventsRequest {
    sourceId: string;
}

/**
 * 
 */
export class ScreeningEventApi extends runtime.BaseAPI {

    /**
     * Gets all screening events by query
     */
    async getScreeningEventsRaw(requestParameters: GetScreeningEventsRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<InternalApiScreeningEvent>>> {
        if (requestParameters.sourceId === null || requestParameters.sourceId === undefined) {
            throw new runtime.RequiredError('sourceId','Required parameter requestParameters.sourceId was null or undefined when calling getScreeningEvents.');
        }

        const queryParameters: any = {};

        if (requestParameters.sourceId !== undefined) {
            queryParameters['sourceId'] = requestParameters.sourceId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/screening-events`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(InternalApiScreeningEventFromJSON));
    }

    /**
     * Gets all screening events by query
     */
    async getScreeningEvents(requestParameters: GetScreeningEventsRequest, initOverrides?: RequestInit): Promise<Array<InternalApiScreeningEvent>> {
        const response = await this.getScreeningEventsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
